import { render, staticRenderFns } from "./TeamManager.vue?vue&type=template&id=6d933e24&scoped=true"
import script from "./TeamManager.vue?vue&type=script&lang=ts"
export * from "./TeamManager.vue?vue&type=script&lang=ts"
import style0 from "./TeamManager.vue?vue&type=style&index=0&id=6d933e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d933e24",
  null
  
)

export default component.exports